import { classOptions, makeOptions } from 'modules/equipment';
import { lowTorqueEngineTypes } from '../constants';
import { ENGINE_TORQUE_MODE } from '@trnsact/business-criteria';

export const getTrnsactMakeValueFromVinDecoding = (manufacturer: string): string => {
  const trnsactEquipmentMakeOptions = makeOptions.map(o => o.value);
  const equipmentMake =
    trnsactEquipmentMakeOptions.find(make => make.toLowerCase() === manufacturer.toLowerCase()) ||
    trnsactEquipmentMakeOptions.find(make => manufacturer.toLowerCase().includes(make.toLowerCase()));
  return equipmentMake || '';
};

export const getTrnsactClassValueFromVinDecoding = (gvwr: string): string => {
  const trnsactEquipmentClassOption = classOptions.map(o => o.value);
  const equipmentClass = trnsactEquipmentClassOption.find(o => gvwr.toLowerCase().includes(o.toLowerCase()));
  return equipmentClass || '';
};

export const getEngineTypeFromVinDecoding = (engineModel: string): [string, string] | [] => {
  const fullEngineType = engineModel.match(/DD\w+/)?.[0];
  const shortEngineType = engineModel.match(/DD\d+/)?.[0];
  if (!fullEngineType || !shortEngineType) return [];
  return [fullEngineType, shortEngineType];
};

export const getTorqueByEngineType = (fullEngineType: string): ENGINE_TORQUE_MODE =>
  lowTorqueEngineTypes.includes(fullEngineType) ? ENGINE_TORQUE_MODE.LOW : ENGINE_TORQUE_MODE.HIGH;
